import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BaseDialogComponent } from '@helpers/base';

@Component({
    selector: 'version-dialog',
    templateUrl: './version.dialog.html',
    styleUrls: ['./dialog.scss'],
    standalone: true,
    imports: [MatToolbarModule, MatDialogModule, MatIconModule, MatButtonModule],
})
export class VersionDialog extends BaseDialogComponent {
    public title: string;
    public message: string;

    public REQUIRES_SIGNIN: boolean;

    constructor(
        public dialogRef: MatDialogRef<VersionDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        super(dialogRef);
    }

    ngOnInit() {
        if (this.data.updateType === 'major' || this.data.updateType === 'minor') {
            this.REQUIRES_SIGNIN = true;
        }
    }
}
